var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#calendar-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.527 13.746h13.781a.53.53 0 0 0 .338-.122c.133-.11 3.152-2.708 3.336-8.316H3.181c-.184 5.09-2.964 7.483-2.993 7.507a.529.529 0 0 0 .339.931M17.473 2.144h-2.637v-.527a.52.52 0 0 0-.528-.528.52.52 0 0 0-.527.528v.527h-2.672v-.527a.52.52 0 0 0-.527-.528.52.52 0 0 0-.528.528v.527H7.417v-.527a.52.52 0 0 0-.527-.528.52.52 0 0 0-.527.528v.527H3.726a.52.52 0 0 0-.527.527v1.583H18V2.67a.52.52 0 0 0-.527-.527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.323 14.433a1.6 1.6 0 0 1-1.015.368H3.198v1.582c0 .291.236.527.528.527h13.747a.527.527 0 0 0 .527-.527V10.47c-1.017 2.495-2.436 3.76-2.677 3.961"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgCalendarIcon;